import { AHText, Box, TodoStatusCircle } from "arkh";
import React from "react";
import { Pressable } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { graphql, useFragment, useMutation } from "react-relay";
import { ProductExpireBatchStatusFooter_productExpireBatch$key } from "./__generated__/ProductExpireBatchStatusFooter_productExpireBatch.graphql";
import { ProductExpireBatchStatusFooterSetBatchStatusMutation } from "./__generated__/ProductExpireBatchStatusFooterSetBatchStatusMutation.graphql";
import { NoProductsLeftLabel } from "./NoProductsLeftLabel";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";
export function ProductExpireBatchStatusFooter(props: {
  batch: ProductExpireBatchStatusFooter_productExpireBatch$key;
}) {
  const batch = useFragment(
    graphql`
      fragment ProductExpireBatchStatusFooter_productExpireBatch on StoreProductExpireBatch {
        status
        id
        product @required(action: THROW) {
          id
        }
        deadlineAtDate {
          isoString
        }
      }
    `,
    props.batch
  );

  const [setBatchStatus] =
    useMutation<ProductExpireBatchStatusFooterSetBatchStatusMutation>(graphql`
      mutation ProductExpireBatchStatusFooterSetBatchStatusMutation(
        $productId: ID!
        $productExpireBatchId: ID!
        $status: StoreProductExpireBatchStatus!
        $employeeId: ID
      ) @raw_response_type {
        storeProduct(id: $productId) {
          expireBatch(id: $productExpireBatchId) {
            setBatchStatus(status: $status, employeeId: $employeeId) {
              id
              status
            }
          }
        }
      }
    `);

  const { currentEmployeeId } = usePersistedEmployeeId();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const insets = useSafeAreaInsets();
  return (
    <Box
      space="medium"
      color="surface-primary"
      insets={{
        bottom: isCompact ? insets.bottom : 0,
      }}
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box style={{ flex: 1 }}>
        <AHText type="title-small">
          <NoProductsLeftLabel />
        </AHText>
      </Box>
      <Pressable
        onPress={() => {
          const status = batch.status === "INACTIVE" ? "ACTIVE" : "INACTIVE";
          setBatchStatus({
            optimisticResponse: {
              storeProduct: {
                expireBatch: {
                  setBatchStatus: {
                    id: batch.id,
                    status,
                  },
                },
              },
            },
            variables: {
              productId: batch.product.id,
              productExpireBatchId: batch.id,
              status,
              employeeId: currentEmployeeId,
            },
          });
        }}
        hitSlop={10}
      >
        <TodoStatusCircle
          size="medium"
          expireAtISO={batch.deadlineAtDate.isoString}
          status={batch.status === "INACTIVE" ? "DONE" : "PENDING"}
        />
      </Pressable>
    </Box>
  );
}
